import { dayjs } from "neetocommons/utils";
import { substituteVariables } from "neetoeditor";

import { DATE_TIME_FORMAT } from "./constants";

const dayTimeFormatter = timestamp =>
  // eslint-disable-next-line @bigbinary/neeto/use-standard-date-time-formats
  dayjs.utc(timestamp).local().format(DATE_TIME_FORMAT);

export const formatMessageContent = ({ message, startsAt, endsAt }) =>
  substituteVariables(message, [
    {
      label: "starts_at",
      key: "starts_at",
      value: dayTimeFormatter(startsAt),
    },
    {
      label: "ends_at",
      key: "ends_at",
      value: dayTimeFormatter(endsAt),
    },
  ]);
